// Legacy Wix → new-URL redirects.
// Operator-supplied CSV (74 rows) + general fallbacks.
// This lives in the React SPA because the preview ingress routes non-API
// traffic to React directly, bypassing FastAPI.

export const REDIRECTS = {
  // --- Product pages (Wix /product-page/<handle>) ---
  "/product-page/lost-alice-pc-keycaps-104-key-set": "/p/lost-alice-pc-keycaps-104-key-set",
  "/product-page/talongames-type-99-mousepad-490-x-420": "/p/talongames-type-99-mousepad-490-x-420",
  "/product-page/capere-flame-fps-mousepad-saturn-and-zero": "/p/capere-flame-fps-mousepad-saturn-and-zero",
  "/product-page/scyrox-v8": "/p/scyrox-v8",
  "/product-page/loadout-inferno-g": "/p/loadout-inferno-g",
  "/product-page/atk-dragonfly-a9-series": "/p/atk-dragonfly-a9-series",
  "/product-page/keystar-aurra-60-acrylic-case": "/p/keystar-aurra-60-acrylic-case",
  "/product-page/olympus-poron-mousepads": "/p/olympus-poron-mousepads",
  "/product-page/night-demon-printed-pbt-keycaps": "/p/night-demon-printed-pbt-keycaps",
  "/product-page/mchose-ace-68-he-ace68-series": "/p/mchose-ace-68-he-ace68-series",
  "/product-page/atk-reverie-anime-gaming-mousepad": "/p/atk-reverie-anime-gaming-mousepad",
  "/product-page/vgn-vxe-r1-series-wireless-gaming-mouse": "/p/vgn-vxe-r1-series-wireless-gaming-mouse",
  "/product-page/blackberry-pink-topo-4-0-keycap-set": "/p/blackberry-pink-topo-4-0-keycap-set",
  "/product-page/atk-x83-xsoft-gaming-mousepad": "/p/atk-x83-xsoft-gaming-mousepad",
  "/product-page/ausdom-g06-professional-edition": "/p/ausdom-g06-professional-edition",
  "/product-page/atk-nana-anime-gaming-mousepad": "/p/atk-nana-anime-gaming-mousepad",
  "/product-page/mchose-ace-60-pro-series-ace-60-he-pro": "/p/mchose-ace-60-pro-series-ace-60-he-pro",
  "/product-page/wlmouse-feirenzai-beast-g-limited-edition": "/p/wlmouse-feirenzai-beast-g-limited-edition",
  "/product-page/vgn-y2-series": "/p/vgn-y2-series",
  "/product-page/leobog-a80-rt-series": "/p/leobog-a80-rt-series",
  "/product-page/xinmeng-zero-1-series": "/p/xinmeng-zero-1-series",
  "/product-page/mmd-nova-60-cnc-aluminium-case-gh60": "/p/mmd-nova-60-cnc-aluminium-case-gh60",
  "/product-page/aula-win60he-win60-he-series": "/p/aula-win60he-win60-he-series",
  "/product-page/womier-time-metal-finish-pbt-keycaps": "/p/womier-time-metal-finish-pbt-keycaps",
  "/product-page/atk-knight-zodiac-horse-limited-edition-mousepad": "/p/atk-knight-zodiac-horse-limited-edition-mousepad",
  "/product-page/mchose-v9-pro-wireless-gaming-mouse": "/p/mchose-v9-pro-wireless-gaming-mouse",
  "/product-page/atk-dragonfly-y9-series": "/p/atk-dragonfly-y9-series",
  "/product-page/x-raypad-obsidian-air": "/p/x-raypad-obsidian-air",
  "/product-page/irok-mg75-pro-mg75-max-he": "/p/irok-mg75-pro-mg75-max-he",
  "/product-page/talongames-raven-series-mouse-skates": "/p/talongames-raven-series-mouse-skates",
  "/product-page/mad60-he-flagship-4-0": "/p/mad60-he-flagship-4-0",
  "/product-page/bythere-tgf1-tempered-glass-mousepad": "/p/bythere-tgf1-tempered-glass-mousepad",

  // --- Category pages (Wix /category/<handle>) ---
  "/category/open-box": "/collections/open-box",
  "/category/accessories": "/collections/accessories",
  "/category/rapid-trigger-mice": "/collections/rapid-trigger-mice",
  "/category/audio": "/collections/audio",
  "/category/80-layout-keyboards": "/collections/80-layout-keyboards",
  "/category/magnesium-gaming-mouse": "/collections/magnesium-gaming-mouse",
  "/category/mice": "/collections/mice",
  "/category/65-layout-keyboards": "/collections/65-layout-keyboards",
  "/category/switches": "/collections/switches",
  "/category/all-products": "/collections/all-products",
  "/category/freebies": "/collections/freebies",
  "/category/diy-keyboard-pcb-modules": "/collections/diy-keyboard-pcb-modules",
  "/category/in-stock": "/collections/in-stock",
  "/category/keyboards": "/collections/keyboards",
  "/category/best-sellers": "/collections/best-sellers",
  "/category/60-keyboards": "/collections/60-keyboards",
  "/category/mchose": "/collections/mchose",
  "/category/vgn": "/collections/vgn",
  "/category/75-layout-keyboards": "/collections/75-layout-keyboards",
  "/category/atk": "/collections/atk",
  "/category/keycaps": "/collections/keycaps",
  "/category/mousepads": "/collections/mousepads",
  "/category/akko-monsgeek": "/collections/akko-monsgeek",

  // --- Wix page routes → new static routes ---
  "/about-us": "/about",
  "/contact-us": "/contact",
  "/pre-order-policy": "/track-order",
  "/refunds-and-returns": "/shipping-returns",
  "/cod-policy": "/shipping-returns",
  "/pre-order-tracking": "/track-order",
  "/warranty-and-rma": "/warranty",
  "/shipping-policy": "/shipping-returns",
  "/faqs": "/faq",
  "/refer-friends": "/",
  "/gear-up-card": "/",
  "/mouse-finder": "/collections/mice",
  "/referral": "/",
  "/loyalty": "/",
  "/terms-of-service": "/terms",
  "/community-loadouts-gamer-setups-india": "/",
  "/privacy-policy": "/privacy",
  "/e-waste-management": "/terms",
};

// Resolve a path to a redirect target. Returns null if no rule applies.
export function resolveRedirect(pathname) {
  if (!pathname) return null;
  const norm = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");

  // 1) Exact match from operator CSV
  if (Object.prototype.hasOwnProperty.call(REDIRECTS, norm)) {
    return REDIRECTS[norm];
  }

  // 2) General Wix fallbacks (cover anything not in the CSV)
  if (norm.startsWith("/product-page/")) {
    return "/p/" + norm.slice("/product-page/".length);
  }
  if (norm.startsWith("/old-product-page/")) {
    return "/p/" + norm.slice("/old-product-page/".length);
  }
  if (norm.startsWith("/product/")) {
    return "/p/" + norm.slice("/product/".length);
  }
  if (norm.startsWith("/category/")) {
    return "/collections/" + norm.slice("/category/".length);
  }
  if (norm.startsWith("/store/")) {
    return "/collections/" + norm.slice("/store/".length);
  }
  if (norm === "/store") {
    return "/collections/keyboards";
  }

  return null;
}
